
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Play } from "lucide-react";

interface VideoPreviewProps {
  selectedVideo: {
    url: string;
    title: string;
  } | null;
  analyzing: boolean;
  onAnalyze: () => void;
}

const VideoPreview: React.FC<VideoPreviewProps> = ({
  selectedVideo,
  analyzing,
  onAnalyze
}) => {
  if (!selectedVideo) return null;

  return (
    <div className="grid gap-4 py-4">
      <h3 className="text-lg font-semibold">{selectedVideo.title}</h3>
      
      <div className="relative aspect-video w-full overflow-hidden rounded-lg border">
        <video 
          src={selectedVideo.url} 
          controls 
          className="h-full w-full object-contain"
        />
      </div>
      
      <div className="flex justify-center mt-4">
        <Button
          onClick={onAnalyze}
          disabled={analyzing}
          className="w-40"
        >
          {analyzing ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Analyzing...
            </>
          ) : (
            <>
              <Play className="mr-2 h-4 w-4" />
              Analyze Video
            </>
          )}
        </Button>
      </div>
    </div>
  );
};

export default VideoPreview;
